import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "suitecrowd_cookie_consent_v1";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      // Delay slightly for smoothness
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };
  const reject = () => {
    localStorage.setItem(KEY, "rejected");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-6 left-6 right-6 md:left-8 md:right-auto md:max-w-md z-50 bg-[#121212] text-white p-6 md:p-7 shadow-[0_20px_60px_rgba(0,0,0,0.35)] border border-neutral-800"
    >
      <div className="sc-overline mb-3" style={{ color: "rgba(255,255,255,0.6)" }}>
        Cookie e Privacy
      </div>
      <p className="text-[13px] leading-relaxed text-neutral-300 mb-5">
        Utilizziamo cookie tecnici essenziali e strumenti di analisi anonimizzata
        per migliorare l'esperienza. Nessun tracciamento pubblicitario. Consulta la{" "}
        <Link to="/privacy" className="underline decoration-neutral-500 hover:text-white">
          privacy policy
        </Link>
        .
      </p>
      <div className="flex gap-3">
        <button
          data-testid="cookie-accept-btn"
          onClick={accept}
          className="sc-btn-primary bg-white text-[#0B192C] hover:bg-white/90 text-[11px]"
          style={{ padding: "10px 20px" }}
        >
          Accetta
        </button>
        <button
          data-testid="cookie-reject-btn"
          onClick={reject}
          className="text-[11px] tracking-[0.2em] uppercase text-neutral-400 hover:text-white transition-colors"
        >
          Solo essenziali
        </button>
      </div>
    </div>
  );
}
